import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';
import Section from 'wrappers/Section/Section';

export interface IPartner {
  content: string;
  image: string;
  title: string;
}

type Props = IPartner & {
  className?: string;
  direction: 'left' | 'right';
  hightlightBackground: string;
} & WithColorQueryProps &
  IWithCountryProps;

export const Partner: React.SFC<Props> = props => {
  const background = props.hightlightBackground;

  const color = getTextColor(background);

  return (
    <StyledSection
      background={background}
      color={color}
      direction={props.direction}
      width={1000}
    >
      <Container
        background={background}
        color={color}
        direction={props.direction}
        className={props.className}
      >
        <Wrapper>
          <Title>{props.title}</Title>
          <Markdown className="partner-md" source={props.content} />
        </Wrapper>
        <ImageWrapper>
          <Image src={props.image} alt="" />
        </ImageWrapper>
      </Container>
    </StyledSection>
  );
};

const Container = styled.div<{
  direction: string;
  background: string;
  color: string;
}>`
  display: flex;
  flex-direction: ${p => (p.direction === 'left' ? 'row' : 'row-reverse')};
  margin-bottom: 30px;
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
  }
  .partner-md {
    p {
      font-size: 15px;
    }
  }
`;

const StyledSection = styled(Section)<{
  direction: string;
  background: string;
  color: string;
}>`
  color: ${p => (p.direction === 'left' ? 'initial' : '#000')};
  background: ${p => (p.direction === 'left' ? 'initial' : p.background)};
`;

const Title = styled.h4`
  font-weight: bold;
  font-size: 35px;
  margin-bottom: 10px;
  @media (max-width: 1000px) {
    font-size: 20px;
  }
`;

const Image = styled.img`
  max-width: 100%;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  padding: 15px;
  flex: 0 0 60%;
`;

const ImageWrapper = styled.div`
  padding: 15px;
  flex: 0 0 40%;
  text-align: center;
`;

export default withCountry(withColorQuery(Partner));



// WEBPACK FOOTER //
// ./src/components/Partner/Partner.tsx